import React from 'react';
import { FcGoogle } from 'react-icons/fc';
import { HiOutlineBriefcase, HiOutlineChartBar, HiOutlineUsers } from 'react-icons/hi';

const Login: React.FC = () => {
  const handleGoogleLogin = (): void => {
    // Redirect to backend Google OAuth endpoint
    window.location.href = `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/auth/google`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="bg-primary-600 rounded-full p-3">
              <HiOutlineBriefcase className="h-8 w-8 text-white" />
            </div>
          </div>
          <h1 className="text-3xl font-bold text-secondary-900 mb-2">
            Job Tracker
          </h1>
          <p className="text-secondary-600">
            Manage your job search effectively
          </p>
        </div>

        {/* Login Card */}
        <div className="card shadow-large">
          <div className="card-header text-center">
            <h2 className="card-title text-xl">Welcome back</h2>
            <p className="card-description">
              Sign in to your account to continue
            </p>
          </div>
          
          <div className="card-content">
            <button
              onClick={handleGoogleLogin}
              className="w-full flex items-center justify-center gap-3 bg-white border border-secondary-300 text-secondary-900 px-4 py-3 rounded-lg hover:bg-secondary-50 transition-colors duration-200 font-medium"
            >
              <FcGoogle className="h-5 w-5" />
              Continue with Google
            </button>
          </div>
        </div>

        {/* Features */}
        <div className="mt-8 space-y-4">
          <div className="text-center">
            <h3 className="text-sm font-medium text-secondary-700 mb-4">
              What you can do with Job Tracker
            </h3>
          </div>
          
          <div className="grid grid-cols-1 gap-3">
            <div className="flex items-center gap-3 text-sm text-secondary-600">
              <div className="bg-primary-100 rounded-full p-2">
                <HiOutlineBriefcase className="h-4 w-4 text-primary-600" />
              </div>
              <span>Track job applications and their progress</span>
            </div>
            
            <div className="flex items-center gap-3 text-sm text-secondary-600">
              <div className="bg-primary-100 rounded-full p-2">
                <HiOutlineUsers className="h-4 w-4 text-primary-600" />
              </div>
              <span>Manage company contacts and interactions</span>
            </div>
            
            <div className="flex items-center gap-3 text-sm text-secondary-600">
              <div className="bg-primary-100 rounded-full p-2">
                <HiOutlineChartBar className="h-4 w-4 text-primary-600" />
              </div>
              <span>View analytics and job search insights</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-xs text-secondary-500">
          <p>
            By signing in, you agree to our{' '}
            <button 
              type="button"
              className="text-primary-600 hover:text-primary-700 underline bg-transparent border-0 p-0 font-inherit cursor-pointer"
              onClick={() => console.log('Terms of Service clicked')}
            >
              Terms of Service
            </button>{' '}
            and{' '}
            <button 
              type="button"
              className="text-primary-600 hover:text-primary-700 underline bg-transparent border-0 p-0 font-inherit cursor-pointer"
              onClick={() => console.log('Privacy Policy clicked')}
            >
              Privacy Policy
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login; 